import { environment } from 'environments/environment';

export const Constants = {
    val_tipoDocumentoIdentidad: 1,
    val_tipoSexo: 2,
    val_tipoLineaMovil: 3,
    val_tipoGrupoSangre: 4,
    val_tipoDocumento: 5,
    val_tipoContrato: 6,
    val_tipoDependendencia: 7,
    val_tipoEstadoLaboral: 8,
    val_tipoBanco: 9,
    val_tipoAporte: 10,
    val_tipoSistemaPension: 11,
    val_tipoDescuentoCafae: 12,
    val_tipoGeneral: 13,
    val_tipoSolicitudes: 14,
    val_tipoArchivo: 15,
    val_tipoEstadoDocumento: 16,
    // val_tipoEstadoLaboral: 17,
    val_tipoEncargatura: 18,
    val_tipoEstadoCivil: 19,
    val_tipoEstadoVacacion: 20,
    val_tipoFuncionArea: 22,
    val_tipoFamiliar: 23,

    const_cero: 0,
    const_estado_activo: 1,
    const_vacio: '',

    //EDWIN
    val_tipoSCTR: 28,
    val_const_tipo_documento_solicitud: 29,
    //val_tipoRegimenLaboral: 29,
    val_tipoNivelRegimenLaboral: 30,

    val_const_tipo_unidad: 39,
    val_const_tipo_area: 40,
    val_const_tipo_equipo: 41,
    val_const_tipo_otros: 42,
    val_const_tipo_estado_laboral_activo: 44,

    val_const_tipo_aporte_privado: 67,

    val_const_tipo_general_todas_solicitudes: 82,
    val_const_tipo_de_solicitudes: 83,

    val_const_tipo_SolicitudPermisoConGoce: 84,
    val_const_tipo_sol_perm_con_goce_onomastico: 85,
    val_const_tipo_sol_perm_con_goce_cita_judicial: 86,
    val_const_tipo_sol_perm_con_goce_cap_oficializada: 87,
    val_const_tipo_sol_perm_con_goce_cita_medica: 88,
    val_const_tipo_sol_perm_con_goce_examen_medico_ocup: 210,
    val_const_tipo_sol_perm_con_goce_lactancia: 89,

    val_const_tipo_SolicitudPermisoCompensable: 90,
    val_const_tipo_sol_perm_comp_feriado_compensable: 92,

    val_const_tipo_SolicitudPermisoSinGoce: 95,
    val_const_tipo_AsustosParticulares: 96,

    val_const_tipo_SolicitudVacaciones: 97,
    val_const_tipo_sol_vac_fraccionado: 98,
    val_const_tipo_sol_vac_adelanto: 99,
    val_const_tipo_sol_vac_normal: 100,
    val_const_tipo_sol_vac_fraccionado_media_jornada: 116,
    val_const_tipo_vac_adelanto_media_jornada: 220,
    //val_const_tipo_vac_adelanto_media_jornada: 'ADMEJO',

    val_const_tipo_SolicitudComisionDeServicio: 101,
    val_const_tipo_sol_com_lima_metropolitana: 102,
    val_const_tipo_SolicitudPermisoDeSalud: 105,

    val_const_tipo_SolicitudLicenciaConGoce: 107,
    val_const_tipo_sol_lic_con_fallec_direct: 108,

    val_const_tipo_SolicitudLicenciaSinGoce: 113,
    val_const_tipo_sol_lic_sin_goce_remuneraciones: 114,

    val_const_tipo_SolicitudCompensacion: 115,
    val_const_tipo_sol_comp_frac_media_jornada: 116,
    val_const_tipo_sol_comp_solicitud_compensac: 117,

    val_const_tipo_solicitudTrabajoRemoto: 148,
    val_const_tipo_sol_trabajo_remoto: 149,
    val_const_tipo_sol_remoto_completo: 150,
    val_const_tipo_sol_licencia_con_goce_remto: 151,

    val_const_tipo_sol_perm_con_goce_capacitacion: 161,

    val_const_tipo_SolicitudMedidaCautelar: 175,
    val_const_tipo_sol_med_med_caut_excepcional: 176,

    val_const_tipo_SolicitudTeletrabajo: 177,

     val_const_tipo_SolicitudBicicleta: 214,

    val_const_tipo_SolicitudInformeMensual: 205,
    val_const_tipo_SolicitudInformeMensual2: 206,

    val_const_tipo_SolicitudOmision: 180,
    val_const_tipo_SolicitudOmision2: 181,

    val_const_tipo_sol_comp_solicitud_sobretiempo: 182,
    val_const_tipo_sol_comp_solicitud_sobretiempo2: 183,


    val_const_tipo_sol_tele_teletrabajo: 178,
    val_const_tipo_sol_infome_mensual: 205,
    val_const_tipo_sol_infome_mensual2: 206,

    val_const_tipo_archivo_otros: 121,

    val_const_tipo_est_doc_pendiente: 123,
    val_const_tipo_est_doc_aprobado: 124,
    val_const_tipo_est_doc_incompleto: 125,
    val_const_tipo_est_doc_Rechazado: 126,

    val_const_tipo_sol_comp_asistencia_cac: 132,

    val_const_tipo_SolicitudPermisoDeSaludSubsidio: 131,

    val_const_tipo_estadoVacacion: 143,
    val_const_tipo_est_vac_gozado: 145,

    val_const_tipo_perfil_jeferrhh: 2,
    val_const_tipo_perfil_personalrrhh: 3,

    val_const_tipo_perfil_personalrrhhsalud: 5,


    val_const_tipo_control_sistema_planilla: 1,
    val_const_tipo_control_sistema_mantenimiento: 2,

    val_const_pais_peru: 175,
    val_const_departamento_lima: 15,
    val_const_provincia_lima: 127,
    val_const_distrito_lima: 1251,

    val_tabla_documento: 1,
    val_tabla_desplazamiento: 2,
    val_tabla_contrato: 3,
    val_tabla_encargatura: 4,
    val_tabla_vacacion: 5,

    val_const_dependencia_direccion_ejecutiva: 1,
    val_const_dependencia_unidad_administracion: 4,
    val_const_dependencia_area_territorial: 37,
    val_const_dependencia_equipo_especial_reconstruccion: 34,
    val_const_dependencia_PIRCC: 45,
    val_const_dependencia_Proyectos: 15,


    val_const_dependencia_coordinacion_rural: 42,
    val_const_dependencia_coordinacion_urbano: 41,
    val_const_dependencia_proyectos_especiales: 18,

    val_const_dependencia_rrhh: environment.val_entidad == "PNSU" ? 8 : 2,
    val_const_dependencia_teletrabajadores: 46,

    val_const_sede_central: 1,
    val_const_sede_callao: 2,
    val_const_sede_olaechea: 3,
    val_const_sede_olaechea_pnsu450: 4,
    val_const_sede_canaval: 5,
    val_const_sede_todos: 6,
    val_const_sede_central_maniana: 42,
    val_const_sede_central_tarde: 43,
    val_const_sede_lima_panama: 45,

    val_const_perfil_admin: 0,
    val_const_perfil_servidor: 1,
    val_const_perfil_responsable: 2,
    val_const_perfil_rrhh: 3,
    val_const_perfil_rrhh_nuevo: 57,
    val_const_perfil_rrhh_planilla: 4,
    val_const_perfil_rrhh_salud: 5,
    val_const_perfil_rrhh_personal: 6,

    val_val_token: "token",
    val_val_token_apellidomaterno: "apellidomaterno",
    val_val_token_apellidopaterno: "apellidopaterno",
    val_val_token_correoinstitucional: "correoinstitucional",
    val_val_token_descdependencia: "descdependencia",
    val_val_token_documentoidentidad: "documentoidentidad",
    val_val_token_idcontrato: "idcontrato",
    val_val_token_iddependencia: "iddependencia",
    val_val_token_iddependsuperior: "iddependsuperior",
    val_val_token_idpersona: "idpersona",
    val_val_token_idpersonal: "idpersonal",
    val_val_token_esencargado: "esencargado",
    val_val_token_idusuario: "idusuario",
    val_val_token_nombres: "nombres",
    val_val_token_url: "url",
    val_val_token_listVwContratoPerfilDto: "listVwContratoPerfilDto",
    val_val_token_list_idcargo: "idcargo",
    val_val_token_iddependenciaencargado: "iddependenciaencargado",
    val_val_token_iddependenciadelegado: "iddependenciadelegado",
    val_val_token_iddependenciadesignado: "iddependenciadesignado",
    val_val_token_iddependenciaencargadosuperior: "iddependenciaencargadosuperior",
    val_val_token_iddependenciadelegadosuperior: "iddependenciadelegadosuperior",
    val_val_token_iddependenciadesignadosuperior: "iddependenciadesignadosuperior",
    val_val_token_idsede: "idsede",
    val_val_token_descripcionsede: "descripcionsede",
    val_val_token_ipconexion: "ipconexion",

    val_val_tipo_consulta_before: "BEFORE",
    val_val_tipo_consulta_after: "AFTER",
    val_val_tipo_consulta_all: "ALL",

    //https://jwt.io
    //Solo con el DNI

    val_list_cacs_autorizados: [
        { documentoidentidad: '16702568', region: "AMAZONAS", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIxNjcwMjU2OCJ9.-DymxvrH-e5q7e8oVowH3U-kCUBalWYxIOPf-RSAZwA' },
        { documentoidentidad: '16474935', region: "AMAZONAS", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIxNjQ3NDkzNSJ9.QWNnkTXfcySnluClS2jSFyj7ksuTSk00m2ljPqrUbmc' },
        { documentoidentidad: '40391169', region: "LORETO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiI0MDM5MTE2OSJ9.XxockLrVhF6tfUIPzj9rxCOI16kiRXeBKCsfJ5qE_B8' },
        { documentoidentidad: '05412942', region: "LORETO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIwNTQxMjk0MiJ9.wDnRC5ZPRz3j_Mp4RhuwBbAS8Y9lufwHwN_ArrdaZNQ' },
        { documentoidentidad: '44125799', region: "LORETO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiI0NDEyNTc5OSJ9.2Q-4YnR6oeQFLDEpPUrgrTD7tT7l87WekxnZ5JC36Yg' },
        { documentoidentidad: '41582308', region: "HUANUCO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiI0MTU4MjMwOCJ9.ox__Qd4MACeHbfO_t86ANNiqJE322gdpCrBz1MPSSIM' },
        { documentoidentidad: '22516868', region: "HUANUCO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIyMjUxNjg2OCJ9.mAJcbMO_9nS5SGOpGZXHhImOuuN-jZXJfUYW9cl6I-4' },
        { documentoidentidad: '09475638', region: "HUANUCO", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIwOTQ3NTYzOCJ9.0HzYGeu2lgYJAFXqeN-AyuMYRUJDYdGod1CfNaqeVMs' },

        { documentoidentidad: '00000000', region: "OTROS", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIwMDAwMDAwMCJ9.KEe4YRoBg0b3ZJP9z1lCY8LaJ3RpVjuvA08MVlms22U' },

        // { documentoidentidad: '70067166', region: "VAGOS", item: 'val_cac', val_cac: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkb2N1bWVudG9pZGVudGlkYWQiOiIwMDAwMDAwMCJ9.KEe4YRoBg0b3ZJP9z1lCY8LaJ3RpVjuvA08MVlms22U' },
    ],


    limitefechas: {
        mingeneral: "2019-10-01",
        mintrabajoremoto: "2020-03-16", maxtrabajoremoto: "2023-06-09",
        minteletrabajo: "2023-06-12",
        minasistenciacac: "2022-08-01"
    }

    //mio
    //200123017130.gtdperu.pe  200.123.17.130

    //Elar Farfan Ortiz De Orue
    //client-201.240.180.197.speedy.net.pe  201.240.180.197


}